import React, { Fragment } from 'react'
import * as ReactDOM from 'react-dom'
import { AppButton } from 'qcc';

let globalMessgeInstance: any[] = []

export default {
	confirm(message1: string, isdangerous: boolean = false): Promise<any> {
		return new Promise(resolve => {
			let div = document.createElement('div')

			document.body.appendChild(div)

			let comfirm = () => {
				this.close()
				resolve(true)
			}
			let onClose = () => {
				this.close()
				resolve(false)
			}

			let content = (
				<Fragment>
					<div className="app-warning-bg"></div>
					<div className="app-warning">
						<div className="app-warning-border">
							<div>{message1}</div>
						</div>
						{isdangerous === false ? (
							<AppButton label="确认" action={comfirm} type="primary" />
						) : (
							<AppButton label="删除" action={comfirm} type="dangerous" />
						)}
						<span style={{display:'inline-block',width:20}}></span>
						<AppButton label="取消" action={onClose} type="default" />
					</div>
				</Fragment>
			)
			ReactDOM.render(content, div)
			globalMessgeInstance.push(div)
		})
	},
	alark(message1: string): Promise<any> {
		return new Promise(resolve => {
			let div = document.createElement('div')

			document.body.appendChild(div)

			let onClose = () => {
				this.close()
			}
			/*设置app-dialog-body的高度*/
			let content = (
				<Fragment>
					<div className="app-warning-bg"></div>
					<div className="app-warning">
						<div className="app-warning-border">
							<div>{message1}</div>
						</div>
						<AppButton label="确定" action={onClose} type="primary" />
					</div>
				</Fragment>
			)

			ReactDOM.render(content, div)
			globalMessgeInstance.push(div)
		})
	},

	close() {
		requestAnimationFrame(() => {
			let div = globalMessgeInstance.pop()
			const unmountResult = ReactDOM.unmountComponentAtNode(div)
			if (unmountResult && div.parentNode) {
				div.parentNode.removeChild(div)
			}
		})
	},
}



// WEBPACK FOOTER //
// ./src/qcc/AppMessage/index.tsx